var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{staticClass:"mt-6",attrs:{"id":"report-line-chart","height":"400"}})
}
var staticRenderFns = []

export { render, staticRenderFns }